export default __webpack_public_path__ + "static/media/11.7c76a6da.png";